"use client";

import React from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { MotionImage } from "@/components/ui/Motion";
import Button from "@/components/ui/Motion/button";
import Link from "@/components/ui/Motion/link";
import {
  TypographyH2,
  TypographyH3,
  TypographySmall,
} from "@/components/ui/typography";
import { URLS } from "@/lib/consts";
import { cls } from "@/lib/utils";
import SectionBase from "@/components/ui/sections/section-base";

const SECTION_ID = "project-contact-us";
const IMG = "projects/Sellers/20-print-QC-08820_pfiqln";

interface ContactUsSectionProperties {
  background?: string;
}

function ContactUsSection({
  background = "bg-card",
}: ContactUsSectionProperties) {
  return (
    <SectionBase id={SECTION_ID} background={background}>
      <Card className={cls`flex flex-col md:flex-row`} variant="transparent">
        <CardHeader
          className={cls`flex flex-1 justify-center items-start gap-2 md:gap-4 lg:gap-6`}
        >
          <TypographyH3>CONTACT US</TypographyH3>
          <TypographyH2 className="border-b-0">
            Ready to Begin Making Your Dream Home a Reality?
          </TypographyH2>
          <TypographySmall className={cls`text-foreground`}>
            We&apos;d love to help turn your wild ideas into a place your
            family can call home. Let&apos;s get started with a quick call or
            email, so we can set up a consultation.
          </TypographySmall>

          <div
            className={cls`flex flex-col md:flex-row self-stretch gap-2 md:gap-5`}
          >
            <Button asChild>
              <Link className={cls`w-full`} href={URLS.REQUEST_CONSULTATION}>
                Request A Consultation
              </Link>
            </Button>
          </div>
        </CardHeader>

        <CardContent className={cls`flex flex-1`}>
          <MotionImage
            src={IMG}
            alt=""
            fill
            className={cls`object-cover rounded-md`}
            wrapperClassName={cls`w-full aspect-9/16`}
          />
        </CardContent>
      </Card>
    </SectionBase>
  );
}

export default ContactUsSection;
